export default "__VITE_ASSET__18e3f277__"